import { Controller } from 'stimulus'
import { applyCoupon } from '~/site/pages/cart/coupons'
import { useClickOutside } from 'stimulus-use'
export default class extends Controller {
  static targets = ['formContainer', 'addNewButtonContainer', 'inputField']
  static values = { openByDefault: Boolean }

  connect() {
    useClickOutside(this)
    if (this.inputFieldIsVisible() && !this.isInsideIframe()) this.focusInput()
  }

  applyCoupon(event) {
    event.preventDefault()
    applyCoupon(this.inputFieldTarget.name, this.inputFieldTarget.value)
  }

  toggleForm() {
    this.formContainerTarget.classList.toggle('hidden')
    this.addNewButtonContainerTarget.classList.toggle('hidden')

    if (this.inputFieldIsVisible()) {
      this.focusInput()
    } else {
      this.dispatch('inputHidden')
    }
  }

  clearError() {
    this.inputFieldTarget.classList.remove('text-red-500')
    this.formContainerTarget.querySelector('.error-message')?.remove()
  }

  focusInput() {
    // We are filling the form. let's focus on the promo field
    this.inputFieldTarget.focus()
    this.inputFieldTarget.setSelectionRange(-1, -1)
    this.dispatch('inputFocused')
  }

  isInsideIframe() {
    try {
      return window.self !== window.top
    } catch (e) {
      return true
    }
  }

  inputFieldIsVisible() {
    return (
      this.hasFormContainerTarget &&
      !this.formContainerTarget.classList.contains('hidden')
    )
  }

  clickOutside(event) {
    if (this.inputFieldIsVisible()) {
      if (this.inputFieldTarget.value) {
        this.applyCoupon(event)
      } else if (!this.openByDefaultValue) {
        this.toggleForm()
      }
    }
  }
}
